import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_6538_28838)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = { id: "clip0_6538_28838" }
const _hoisted_6 = ["width", "height", "fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'impact',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M5.67581 6.00871C5.6203 5.9549 5.54603 5.9248 5.46872 5.9248C5.39142 5.9248 5.31714 5.9549 5.26164 6.00871L0.443307 10.827C0.303487 10.9606 0.191736 11.1207 0.114606 11.298C0.0374764 11.4753 -0.00347922 11.6662 -0.00585938 11.8595C0.00303939 12.2435 0.159542 12.6093 0.431127 12.8809C0.702712 13.1525 1.0685 13.309 1.45247 13.3179C1.64714 13.3212 1.84048 13.2852 2.0209 13.212C2.20132 13.1389 2.36512 13.03 2.50247 12.892L7.32664 8.06788C7.38008 8.01336 7.41002 7.94005 7.41002 7.86371C7.41002 7.78737 7.38008 7.71406 7.32664 7.65954L5.67581 6.00871Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M13.7153 5.39009L13.097 4.77176C12.9877 4.66311 12.8399 4.60213 12.6857 4.60213C12.5316 4.60213 12.3838 4.66311 12.2745 4.77176C12.1798 4.86873 12.0544 4.92973 11.9197 4.94428C11.785 4.95884 11.6494 4.92603 11.5362 4.85151C11.423 4.77698 11.3393 4.66538 11.2995 4.53587C11.2596 4.40636 11.2661 4.26701 11.3178 4.14176C11.3806 3.98346 11.3958 3.81029 11.3616 3.64347C11.3275 3.47664 11.2453 3.32342 11.1253 3.20259C10.2912 2.36843 9.95866 2.03593 9.78949 1.89593C9.00502 1.16933 7.98814 0.744729 6.9199 0.697726C5.85167 0.650724 4.80142 0.984371 3.95616 1.63926C3.86021 1.71372 3.78989 1.81628 3.75503 1.93263C3.72016 2.04897 3.72247 2.1733 3.76165 2.28826C3.80083 2.40322 3.87491 2.50309 3.97357 2.57393C4.07223 2.64477 4.19054 2.68305 4.31199 2.68343C4.71572 2.6661 5.11864 2.73286 5.49521 2.87947C5.87177 3.02608 6.21376 3.24934 6.49949 3.53509C6.80283 3.83259 6.95449 4.06593 6.95449 4.22343C6.95316 4.25797 6.9447 4.29187 6.92964 4.32299C6.91458 4.3541 6.89325 4.38177 6.86699 4.40426L6.28366 4.98759C6.25564 5.01364 6.23338 5.04526 6.21831 5.08042C6.20324 5.11558 6.19569 5.15351 6.19616 5.19176C6.19559 5.23089 6.20307 5.26972 6.21812 5.30584C6.23317 5.34196 6.25548 5.37461 6.28366 5.40176L7.92866 7.05259C7.98416 7.10641 8.05844 7.1365 8.13574 7.1365C8.21305 7.1365 8.28732 7.10641 8.34283 7.05259L8.97283 6.41676C9.02706 6.36209 9.09157 6.31869 9.16266 6.28907C9.23374 6.25946 9.30999 6.24421 9.38699 6.24421C9.464 6.24421 9.54025 6.25946 9.61133 6.28907C9.68242 6.31869 9.74693 6.36209 9.80116 6.41676C9.90981 6.52605 9.97079 6.6739 9.97079 6.82801C9.97079 6.98212 9.90981 7.12997 9.80116 7.23926C9.69251 7.34856 9.63153 7.4964 9.63153 7.65051C9.63153 7.80462 9.69251 7.95247 9.80116 8.06176L10.4195 8.68009C10.5836 8.84395 10.806 8.93599 11.0378 8.93599C11.2697 8.93599 11.4921 8.84395 11.6562 8.68009L13.7153 6.62093C13.8009 6.54301 13.8699 6.44858 13.918 6.34332C13.9661 6.23805 13.9924 6.12413 13.9953 6.00843C13.9935 5.89167 13.9678 5.77653 13.9196 5.67016C13.8714 5.56379 13.8019 5.46846 13.7153 5.39009Z",
        fill: __props.color
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_5, [
        _createElementVNode("rect", {
          width: __props.width,
          height: __props.height,
          fill: __props.color
        }, null, 8, _hoisted_6)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})